export default __webpack_public_path__ + "static/media/1789.43f7436e.png";